export enum CryptoCurrency {
  BTC = 'BTC',
}

export enum NonCryptoCurrency {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
}
